<template>
  <svg viewBox="0 0 16 16" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        fill="currentColor"
        d="M7.152 3.266c.28-.043.564-.065.847-.064 2.543 0 4.934 1.83 6.325 4.797-.213.452-.453.89-.72 1.312a.8.8 0 0 0 .04.921.8.8 0 0 0 1.32-.082c.372-.585.696-1.2.967-1.839a.8.8 0 0 0 0-.632C14.316 3.93 11.278 1.602 8 1.602c-.375-.001-.75.03-1.12.096a.811.811 0 1 0 .273 1.6v-.032ZM1.37.236A.803.803 0 0 0 .235 1.37l2.479 2.47A11.69 11.69 0 0 0 .067 7.68a.8.8 0 0 0 0 .64C1.682 12.07 4.721 14.396 8 14.396a7.405 7.405 0 0 0 4.038-1.231l2.591 2.599A.801.801 0 0 0 16 15.196a.8.8 0 0 0-.236-.568L1.37.235Zm5.085 7.348 1.96 1.959a1.6 1.6 0 0 1-1.959-1.959ZM8 12.797c-2.542 0-4.933-1.831-6.317-4.798a9.667 9.667 0 0 1 2.16-3.03L5.256 6.4a3.198 3.198 0 0 0 4.342 4.342l1.27 1.255c-.87.513-1.86.789-2.87.8Z"
      />
    </g>
    <defs>
      <clipPath><path fill="currentColor" d="M0 0h16v16H0z" /></clipPath>
    </defs>
  </svg>
</template>
